import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    if (pw.length < 8) return toast.error("Use at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password updated. Please sign in.");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ background: "radial-gradient(1200px 800px at 20% 10%, #F7E7B6 0%, #F5EFE0 45%, #EFE3C6 100%)" }}>
      <div className="w-full max-w-md rounded-3xl p-8 md:p-10 shadow-2xl"
        style={{ background: "#FFFDF6", border: "1px solid #ECD9A5" }}>
        <div className="font-mono2 text-[10px] tracking-[0.4em] uppercase mb-2" style={{ color: "#B4841F" }}>Reset Password</div>
        <h1 className="font-display text-3xl mb-2" style={{ color: "#2b1a0d" }}>
          {done ? "All done" : "Choose a new password"}
        </h1>
        {done ? (
          <p className="text-sm" style={{ color: "#7a6349" }}>Redirecting to sign-in…</p>
        ) : !token ? (
          <p className="text-sm" style={{ color: "#c0392b" }}>Missing or invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "#B4841F" }} />
              <Input data-testid="new-pw-input" type="password" required minLength={8}
                placeholder="New password (min 8 chars)" value={pw} onChange={e => setPw(e.target.value)}
                className="pl-10 h-12 bg-white" style={{ borderColor: "#ECD9A5", color: "#2b1a0d" }} />
            </div>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "#B4841F" }} />
              <Input data-testid="confirm-pw-input" type="password" required minLength={8}
                placeholder="Confirm password" value={pw2} onChange={e => setPw2(e.target.value)}
                className="pl-10 h-12 bg-white" style={{ borderColor: "#ECD9A5", color: "#2b1a0d" }} />
            </div>
            <Button data-testid="reset-submit-btn" disabled={loading} className="w-full h-12 rounded-full font-bold"
              style={{ background: "#F5C242", color: "#1A1200" }}>
              {loading ? "Updating..." : "Update password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
